import APIService from "./APIService";

class MedicaidService extends APIService {
  add = async (data: any) => {
    const result = await this.post(data, "medicaid-delivery");
    return result ? result.data : null;
  };

  getDetails = async () => {
    const result = await this.get("/medicaid-delivery/details");
    return result ? result.data : null;
  };

  getAllSchedules = async () => {
    const result = await this.get("/medicaid-delivery/schedules");
    return result ? result.data : null;
  };

  getSingleSchedule = async (id: string) => {
    const result = await this.get(`/medicaid-delivery/schedule/${id}`);
    return result ? result.data : null;
  };

  /* ORDERS */
  getMarkets = async () => {
    const result = await this.get("markets/get-markets");
    return result ? result.data : null;
  };

  getCartData = async (
    search: string = "",
    page: number,
    limit: number,
    category_id: string,
    branch_id: string
  ) => {
    const branch = branch_id ? `${"&branch_id=" + branch_id}` : "";
    const result = await this.get(
      "medicaid-delivery/cart?generic=" +
        search +
        "&page=" +
        page +
        "&limit=" +
        limit +
        "&category_id=" +
        category_id +
        branch
    );
    return result ? result.data : null;
  };

  searchOrders = async (
    search: string = "",
    page: number = 1,
    limit: number = 10,
    sort: string,
    status: string
  ) => {
    const result = await this.get(
      "medicaid-delivery/search-orders?generic=" +
        search +
        "&page=" +
        page +
        "&limit=" +
        limit +
        "&sort=" +
        sort +
        "&status=" +
        status
    );
    return result ? result.data : null;
  };

  searchOrdersByDeliveryDate = async (date: string) => {
    const result = await this.get(
      "medicaid-delivery/search-orders-by-delivery-date?date=" + date
    );
    return result ? result.data : null;
  };

  getDiscounts = async (branch_id: string) => {
    const result = await this.get(
      "medicaid-delivery/get-discounts?branch_id=" + branch_id
    );
    return result ? result.data : null;
  };

  createOrder = async (
    discounts: any[],
    payment_options: string[],
    branch_id: string,
    customer_id: string,
    products: any[],
    teller: { _id: string; first_name: string; last_name: string },
    order_type?: string,
    order_status?: string,
    delivery_date?: Date,
    delivery_time?: Date,
    delivery_notes?: string,
    delivery_address?: {
      address_1: string;
      address_2: string;
      city: string;
      state: string;
      zip_code: string;
      country: string;
    },
    qualified_programs?: string[],
    total?: any
  ) => {
    const result = await this.post(
      {
        discounts,
        payment_options,
        branch_id,
        customer_id,
        products,
        teller,
        order_type,
        order_status,
        delivery_date,
        delivery_time,
        delivery_notes,
        delivery_address,
        qualified_programs,
        total,
      },
      "medicaid-delivery/order-create"
    );
    return result ? result.data : null;
  };

  getProductNames = async (query: string) => {
    const result = await this.get("products/lists?query=" + query);
    return result ? result.data : null;
  };

  getOrder = async (id: string) => {
    const result = await this.get("medicaid-delivery/order?id=" + id);
    return result ? result.data : null;
  };

  getOrderDataByCustomer = async (customer_id: string) => {
    const result = await this.get(
      "medicaid-delivery/order-by-customer?customer_id=" + customer_id
    );
    return result ? result.data : null;
  };

  updateCustomerAddress = async (customer_id: string, address: any) => {
    const result = await this.put(
      {
        customer_id,
        address,
      },
      "medicaid-delivery/update-customer-address"
    );
    return result ? result.data : null;
  };

  verifyCode = async (branch_id: string, code: string) => {
    const result = await this.get(
      "medicaid-delivery/code?branch_id=" + branch_id + "&code=" + code
    );
    return result ? result.data : null;
  };

  updateOrder = async (address: any, box: any, price: any, order_id: string, status: string, reason: string, delivery_date_and_time: boolean ) => {
    const result = await this.put(
      {
        address,
        box,
        order_id,
        price,
        status,
        reason,
        delivery_date_and_time,
      },
      "medicaid-delivery/update-order"
    );
    return result ? result.data : null;
  };

  getCartDataFromNames = async (names: string[]) => {
    const result = await this.get(
      "medicaid-delivery/cart-names?query=" + names.join(",")
    );
    return result ? result.data : null;
  };

  getProductSummary = async (start_date: any, end_date: any) => {
    const result = await this.post(
      {
        start_date,
        end_date,
      },
      "medicaid-delivery/product-summary"
    );
    return result ? result.data : null;
  };
}

export default MedicaidService;
